import styled from 'styled-components'

const HeadingBlockContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	width: fit-content;
	border-bottom: 2px solid #f7ed04;
	padding-bottom: 10px;
`

const HeadingBlockTitle = styled.div`
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 400;
	font-size: 20px;
	color: #555;
	span {
		font-size: 48px;
	}

	@media(max-width: 768px){
	font-size: 15px;
	span {
		font-size: 24px;
	}
	}

	@media(max-width: 425px){
	font-size: 13px;

	span {
		font-size: 24px;
	}
	}
	
`

interface HeadingBlockProps {
	label: string
	title: string
}

export const HeadingBlockComponent = ({ label, title }: HeadingBlockProps) => {
	return (
		<HeadingBlockContainer>
			<HeadingBlockTitle>
				{label} <br />
				<span>{title}</span>
			</HeadingBlockTitle>
		</HeadingBlockContainer>
	)
}
